/*
 * all fields that are commented out are fields for which i could not find the mapping
 */

export const fieldMapping = {
  /* startWidget */
  birthdate: 'getUserInput.birthdate',
  street: 'getUserInput.street',
  housenumber: 'getUserInput.housenumber',
  housenumberaddition: 'getUserInput.housenumberaddition',
  housenumber_addition: 'getUserInput.housenumberaddition',
  postcode: 'getUserInput.postcode',
  zipcode: 'getUserInput.postcode',
  city: 'getUserInput.city',
  address: 'getUserInput.fulladdress',
  car_licenceplate: 'getUserInput.licensePlate',
  carMake: 'getUserInput.carMake',
  carModel: 'getUserInput.carModel',
  constructionYear: 'getUserInput.constructionYear',

  /* getUserInput */
  doublemeter: 'getUserInput.doublemeter',
  electricityusagehigh: 'getUserInput.electricityusagehigh',
  electricityusagelow: 'getUserInput.electricityusagelow',
  gasusage: 'getUserInput.gasusage',
  electricitysupplyhigh: 'getUserInput.electricitysupplyhigh',
  electricitysupplylow: 'getUserInput.electricitysupplylow',
  currentprovider: 'getUserInput.currentprovider',
  email: 'getUserInput.optionalemail',
  customertype: 'getUserInput.customertype', // will always be consumer for now
  car_security_class: 'getUserInput.securityClass',
  confirmation: 'apply.confirmation',
  electricitycapacity: 'apply.electricitycapacity',
  // surnamefull: '',
  asap: 'apply.asap',
  gascapacity: 'apply.gascapacity',
  pricesexcludingtax: 'apply.pricesexcludingtax',
  smartmeter: 'getUserInput.smartmeter',
  kilometrage_display: 'getUserInput.kilometrage',
  kilometrage: 'getUserInput.kilometrageParsed',
  schadevrijejaren: 'getUserInput.claimfreeyears',
  carInfo: 'getUserInput.carInfoResponse',
  beveiliging: 'getUserInput.securityClass',
  DatumOpNaam: 'getUserInput.dateToName',

  /* overview */
  id: 'overview.selectedProduct.id',
  referer: 'overview.selectedProduct.referer',
  providerid: 'overview.selectedProduct.provider.id',
  providerName: 'overview.selectedProduct.provider.name',
  dataProvider: 'overview.selectedProduct.attributes.dataProvider',
  leverancierNaam: 'overview.selectedProduct.attributes.policyProvider',
  comparisonId: 'overview.requestLogId',
  products: 'overview.selectedProduct.products',
  betaaltermijn: 'overview.paymentterm',
  swift_user_id: 'global.userid',
  swift_app_id: 'global.sessionid',
  consumentProductOmschrijving: 'overview.selectedProduct.name',
  productomschrijving: 'overview.selectedProduct.description',

  /* ignore the following */
  // companyname: 'getUserInput.currentprovider',
  // companynumber: 'getUserInput.currentprovider',

  /* to be filled on the apply page so no mapping required */
  // domain: 'getUserInput.currentprovider',
  // confirmation: 'getUserInput.currentprovider',
  // salutation: 'getUserInput.currentprovider',
  // initials: 'getUserInput.currentprovider',
  // firstname: 'getUserInput.currentprovider',
  // surnamefull: 'getUserInput.currentprovider',
  // middlename: 'getUserInput.currentprovider',
  // surname: 'getUserInput.currentprovider',
  // phone: 'getUserInput.currentprovider',
  // isresidential: 'getUserInput.currentprovider',
};

export default fieldMapping;
